export default "__VITE_ASSET__C$PEqAF2__"